import * as is from '@redux-saga/is'
import { effectTypes } from 'redux-saga/effects'
import Manager from './Manager'
import { store } from '../redux'
import { enqueueFailedAction } from 'modules/tokenRefresh/actions'

const VERBOSE = false
const PENDING = 'PENDING'
const RESOLVED = 'RESOLVED'
const REJECTED = 'REJECTED'
const CANCELLED = 'CANCELLED'
const isRaceEffect = eff => is.effect(eff) && eff.type === effectTypes.RACE

function time() {
    if (typeof performance !== 'undefined' && performance.now) {
        return performance.now()
    }
    return Date.now()
}

const manager = new Manager()

function rootSagaStarted(desc) {
    if (VERBOSE) {
        console.log('Root saga started:', desc.saga.name || 'anonymous', desc.args)
    }
    manager.setRootEffect(
        desc.effectId,
        Object.assign({}, desc, {
            status: PENDING,
            start: time(),
        })
    )
}

function effectTriggered(desc) {
    if (VERBOSE) {
        console.log('Saga monitor: effectTriggered:', desc)
    }
    manager.set(
        desc.effectId,
        Object.assign({}, desc, {
            status: PENDING,
            start: time(),
        })
    )
}

function effectResolved(effectId, result) {
    if (VERBOSE) {
        console.log('Saga monitor: effectResolved:', effectId, result)
    }

    resolveEffect(effectId, result)
}

function effectRejected(effectId, error) {
    if (VERBOSE) {
        console.log('Saga monitor: effectRejected:', effectId, error)
    }

    const effect = manager.get(effectId)
    const parentEffect = manager.get(effect.parentEffectId)

    if (error && error.status && error.status === 401) {
        const { effect: rejectedEffect } = parentEffect
        if (rejectedEffect && rejectedEffect.payload) {
            const action = rejectedEffect.payload.args[0]
            if (action && action.type === 'LOGIN_WITH_FB') {
                return
            }
            if (action && action.type !== 'REFRESH_TOKEN') {
                store.dispatch(enqueueFailedAction(action))
            }
        }
    }
    rejectEffect(effectId, error)
}

function effectCancelled(effectId) {
    if (VERBOSE) {
        console.log('Saga monitor: effectCancelled:', effectId)
    }
    cancelEffect(effectId)
}

function computeEffectDur(effect) {
    const now = time()
    Object.assign(effect, {
        end: now,
        duration: now - effect.start,
    })
}

function resolveEffect(effectId, result) {
    const effect = manager.get(effectId)

    if (is.task(result)) {
        result.toPromise().then(
            taskResult => {
                if (result.isCancelled()) {
                    cancelEffect(effectId)
                } else {
                    resolveEffect(effectId, taskResult)
                }
            },
            taskError => rejectEffect(effectId, taskError)
        )
    } else {
        computeEffectDur(effect)
        effect.status = RESOLVED
        effect.result = result
        if (isRaceEffect(effect.effect)) {
            setRaceWinner(effectId, result)
        }
    }
}

function rejectEffect(effectId, error) {
    const effect = manager.get(effectId)
    computeEffectDur(effect)
    effect.status = REJECTED
    effect.error = error
    if (isRaceEffect(effect.effect)) {
        setRaceWinner(effectId, error)
    }
}

function cancelEffect(effectId) {
    const effect = manager.get(effectId)
    computeEffectDur(effect)
    effect.status = CANCELLED
}

function setRaceWinner(raceEffectId, result) {
    const winnerLabel = Object.keys(result)[0]
    // eslint-disable-next-line
    for (const childId of manager.getChildIds(raceEffectId)) {
        const childEffect = manager.get(childId)
        if (childEffect.label === winnerLabel) {
            childEffect.winner = true
        }
    }
}

// Export the `sagaMonitor` to pass to the middleware.
export default {
    rootSagaStarted,
    effectTriggered,
    effectResolved,
    effectRejected,
    effectCancelled,
    actionDispatched: () => {},
}
